import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { ILoggerNoiseSpectrumChartData } from '@app/api/interfaces/chart-data/logger-noise-spectrum';
import { ILoggerNoiseHistogramChartData } from '@app/api/interfaces/chart-data/logger-noise-histogram';
import { LoggerNoiseSpectrumMockService } from '@mock/data-services/logger-noise-spectrum-mock.service';
import { LoggerNoiseHistogramMockService } from '@mock/data-services/logger-noise-histogram-mock.service';

@Injectable({
  providedIn: 'root',
})
export class LoggerMeasurementChartDataApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly MOCK_SIGNAL_SPECTRUM: LoggerNoiseSpectrumMockService,
    private readonly MOCK_HISTOGRAM: LoggerNoiseHistogramMockService
  ) {}

  public getSignalSpectrum(
    projectId: string,
    measurementId: string
  ): Observable<IApiResponse<ILoggerNoiseSpectrumChartData, object>> {
    if (this.MOCK_SIGNAL_SPECTRUM.isMockEnabled()) return this.MOCK_SIGNAL_SPECTRUM.get(projectId, measurementId);

    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/logger-measurements/${measurementId}/chart-data/signal-spectrum`;

    return this.httpClient.get<IApiResponse<ILoggerNoiseSpectrumChartData, object>>(url, {
      withCredentials: true,
    });
  }

  public getHistogram(
    projectId: string,
    measurementId: string
  ): Observable<IApiResponse<ILoggerNoiseHistogramChartData, object>> {
    if (this.MOCK_HISTOGRAM.isMockEnabled()) return this.MOCK_HISTOGRAM.get(projectId, measurementId);

    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/logger-measurements/${measurementId}/chart-data/histogram`;

    return this.httpClient.get<IApiResponse<ILoggerNoiseHistogramChartData, object>>(url, {
      withCredentials: true,
    });
  }
}
